import { useIntl } from 'react-intl';

import { ProductsMenuItem } from './products-menu-item';

type ProductsMenuUpsellAreaProps = {
  isJobsPoster?: boolean;
  isCraUser?: boolean;
  isBrandManagerEditor?: boolean;
  isRecruitingConditionMet?: boolean;
};

export const ProductsMenuUpsellArea: React.FC<ProductsMenuUpsellAreaProps> = ({
  isJobsPoster,
  isCraUser,
  isRecruitingConditionMet,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      {!isJobsPoster ? (
        <ProductsMenuItem
          upsellBackground
          isBestseller
          dataTestId="products-menu-item-jobs-poster-upsell"
          link={{
            href: '/recruiting/jobs/create',
            title: formatMessage({
              id: 'MAINNAV_PRODUCTS_MENU_JOBS_POSTER_UPSELL',
            }),
            tracking: { nwt_nav: 'business_solution_job_ad' },
          }}
        />
      ) : null}

      <ProductsMenuItem
        upsellBackground
        dataTestId="products-menu-item-admaster-upsell"
        link={{
          href: 'https://werben.xing.com',
          title: formatMessage({
            id: 'MAINNAV_PRODUCTS_MENU_ADVERTISING_UPSELL',
          }),
          tracking: { nwt_nav: 'business_solution_advertise' },
        }}
      />

      {!isCraUser || (isJobsPoster && isCraUser) ? (
        <ProductsMenuItem
          upsellBackground
          dataTestId="products-menu-item-talent-manager-upsell"
          link={{
            href: 'https://recruiting.xing.com',
            title: formatMessage({
              id: 'MAINNAV_PRODUCTS_MENU_RECRUITING_UPSELL',
            }),
            tracking: { nwt_nav: 'business_solutions_recruiting' },
          }}
        />
      ) : null}
      {isRecruitingConditionMet ? (
        <ProductsMenuItem
          is360Upsell
          dataTestId="products-menu-item-recruiting-360-upsell"
          link={{
            href: 'https://recruiting.xing.com/de/produkte/xing-360',
            title: formatMessage({
              id: 'MAINNAV_PRODUCTS_MENU_RECRUITING_360_UPSELL',
            }),
            tracking: { nwt_nav: 'business_solutions_recruiting' },
          }}
        />
      ) : null}
      <ProductsMenuItem
        dataTestId="products-menu-item-lebenslauf"
        link={{
          href: 'https://www.xing.com/lebenslauf',
          title: formatMessage({
            id: 'MAINNAV_PRODUCTS_MENU_LEBENSLAUF',
          }),
          description: formatMessage({
            id: 'MAINNAV_PRODUCTS_MENU_LEBENSLAUF_DESCRIPTION',
          }),
          tracking: { nwt_nav: 'lebenslauf' },
        }}
      />
    </>
  );
};
